import { MonitoringPage } from "@/features/monitoring/monitoring-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/monitoring")({
  component: MonitoringPage,
});
